<template>
    <div class="table-responsive">
        <table class="table table-hover table-vertical-center">
            <thead v-if="$slots.headers">
            <slot name="headers"/>
            </thead>
            <tbody>
            <slot/>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {}
</script>
